import { useEffect } from 'react';
import { useBranding } from '@/hooks/useBranding';
import {
  buildWorkspaceBrandThemeVariables,
  type WorkspaceBrandThemeVariables,
} from '@/utils/workspaceBrandColor';

const ZOO_PRIMARY_RGB_PROPERTY = '--zoo-primary-rgb';
const ZOO_PRIMARY_HOVER_RGB_PROPERTY = '--zoo-primary-hover-rgb';
const SHADCN_PRIMARY_PROPERTY = '--primary';

function removeWorkspaceBrandThemeVariables(): void {
  const rootStyle = document.documentElement.style;
  rootStyle.removeProperty(ZOO_PRIMARY_RGB_PROPERTY);
  rootStyle.removeProperty(ZOO_PRIMARY_HOVER_RGB_PROPERTY);
  rootStyle.removeProperty(SHADCN_PRIMARY_PROPERTY);
}

function applyWorkspaceBrandThemeVariables(themeVariables: WorkspaceBrandThemeVariables): void {
  const rootStyle = document.documentElement.style;
  rootStyle.setProperty(ZOO_PRIMARY_RGB_PROPERTY, themeVariables.zooPrimaryRgb);
  rootStyle.setProperty(ZOO_PRIMARY_HOVER_RGB_PROPERTY, themeVariables.zooPrimaryHoverRgb);
  rootStyle.setProperty(SHADCN_PRIMARY_PROPERTY, themeVariables.shadcnPrimaryHsl);
}

export function useWorkspaceBrandTheme(): void {
  const { primaryColor } = useBranding();

  useEffect(
    function applyOrResetWorkspaceBrandTheme() {
      const themeVariables = buildWorkspaceBrandThemeVariables(primaryColor);
      if (themeVariables === null) {
        removeWorkspaceBrandThemeVariables();
        return undefined;
      }
      applyWorkspaceBrandThemeVariables(themeVariables);
      return removeWorkspaceBrandThemeVariables;
    },
    [primaryColor]
  );
}
